import React from 'react';
import { PropTypes } from 'prop-types';
import clsx from 'clsx';
import { texts } from 'utils/languages/fr';
import { Typography } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const getMessage = variant => {
    if (variant === 'type') {
        return texts.FILE_TYPE_INCORRECT;
    }
    return texts.FILE_TOO_LARGE;
};

const useStyles = makeStyles(theme => ({
    error: {
        color: theme.palette.error.main,
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
            textAlign: 'center',
        },
        '&$margin': {
            marginLeft: 40,
        },
    },
    margin: {},
}));

const FileErrorMessage = props => {
    const { variant, useMargin = true, ...rest } = props;
    const classes = useStyles();

    return (
        <Typography
            variant="caption"
            className={clsx({ [classes.error]: true, [classes.margin]: useMargin })}
            {...rest}
        >
            {getMessage(variant)}
        </Typography>
    );
};

FileErrorMessage.propTypes = {
    variant: PropTypes.oneOf(['type', 'size']),
    useMargin: PropTypes.bool,
};

export default FileErrorMessage;
